import * as React from 'react';

import { CookieBannerContainer } from '../../common/components/cookieBanner/cookieBannerContainer';
import { FooterContainer } from '../../common/components/footer/footerContainer';

export const Footer: React.StatelessComponent<{}> = () => {
  return (
<React.Fragment>
		<footer id="footer">
			<FooterContainer/>
		</footer>
		<CookieBannerContainer />
</React.Fragment>
  );
}


// WEBPACK FOOTER //
// ./src/components/shared/footer.tsx